import { ForgotPasswordPage } from "@/main/components/features/forgot_password/ForgotPasswordPage"

export const ForgotPassword = () => {
	return <ForgotPasswordPage />
}

export default ForgotPassword
